import { render, staticRenderFns } from "./AppAlertDistribution.vue?vue&type=template&id=6997b9e0&scoped=true&"
import script from "./AppAlertDistribution.vue?vue&type=script&lang=js&"
export * from "./AppAlertDistribution.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertDistribution.vue?vue&type=style&index=0&id=6997b9e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997b9e0",
  null
  
)

export default component.exports